import React, {FC} from 'react';
import {
  MemoryRouter as OriginalMemoryRouter,
  BrowserRouter as OriginalBrowserRouter,
  Router as OriginalRouter,
  BrowserRouterProps,
} from 'react-router-dom';
import {
  MemoryRouterProps,
  RouterProps,
  StaticRouter as OriginalStaticRouter,
  StaticRouterProps,
} from 'react-router';
import {RouterCustomProvider, Context} from './context';
import {HistoryEventHandler} from './HistoryEventHandler';

export const Router: FC<React.PropsWithChildren<Context & RouterProps>> = ({
  children,
  initialLocation,
  force404,
  ...props
}) => {
  return (
    <RouterCustomProvider initialLocation={initialLocation} force404={force404}>
      <OriginalRouter {...props}>{children}</OriginalRouter>
    </RouterCustomProvider>
  );
};

export const MemoryRouter: FC<
  React.PropsWithChildren<Context & MemoryRouterProps>
> = ({children, initialLocation, force404, ...props}) => {
  return (
    <RouterCustomProvider initialLocation={initialLocation} force404={force404}>
      <OriginalMemoryRouter {...props}>{children}</OriginalMemoryRouter>
    </RouterCustomProvider>
  );
};

export const BrowserRouter: FC<
  React.PropsWithChildren<Context & BrowserRouterProps>
> = ({children, initialLocation, force404, ...props}) => {
  return (
    <RouterCustomProvider initialLocation={initialLocation} force404={force404}>
      <OriginalBrowserRouter {...props}>
        <HistoryEventHandler />
        {children}
      </OriginalBrowserRouter>
    </RouterCustomProvider>
  );
};

export const StaticRouter: FC<
  React.PropsWithChildren<Context & StaticRouterProps>
> = ({children, initialLocation, force404, ...props}) => {
  return (
    <RouterCustomProvider
      initialLocation={initialLocation}
      routerContext={props.context}
      force404={force404}
    >
      <OriginalStaticRouter {...props}>{children}</OriginalStaticRouter>
    </RouterCustomProvider>
  );
};

export type ReactRouterProps = Context &
  (MemoryRouterProps | BrowserRouterProps | StaticRouterProps);
